import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/search_ic.svg';
const _withScopeId = n => (_pushScopeId("data-v-16a1ac99"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "courseWrapper border-box" };
const _hoisted_2 = { class: "searchBox" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "gray-9" }, "搜索", -1));
const _hoisted_6 = [
    _hoisted_4,
    _hoisted_5
];
const _hoisted_7 = { class: "filterWrapper" };
const _hoisted_8 = { class: "num font-24" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 1,
    class: "p-t16"
};
const _hoisted_11 = { class: "nomore" };
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "text-overflow font-24" };
import { nextTick, onMounted, ref, watch, computed } from 'vue';
import BetterScroll from '@/components/common/BetterScroll.vue';
import searchTabs from '@/components/course/searchTabs.vue';
import Empty from '@/components/common/Empty.vue';
import CourseListVue from '@/components/course/courseList.vue';
import omoListItem from '@/components/list/omoListItem.vue';
import filterTab from '@/components/course/filterTab.vue';
import HeaderBar from '@/components/common/Header.vue';
import AppTopBar from '@/components/common/AppTopBar.vue';
import { useCourseData, totalCount, courseLoading, useVipList, useSubDep, useCourseType, activeSubType, activeComing, loading, activeFilter } from '@/components/course/search';
import { appPort, jumpModuleApp, pxToRem } from '@/widget/index';
import { weixinShare, appFullScreen, getAppBarHeight, androidPort, versionCompare } from '@/widget';
import { useRoute } from 'vue-router';
import router from '@/router';
import { hostPath } from '@/public/utils/basePath';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const route = useRoute();
        const isApp = appPort();
        // 金刚区 公开课、omo、大师课
        const showHeader = isApp && route.path != '/course';
        let barH = getAppBarHeight();
        const barHeight = ref(pxToRem(barH));
        const showTop = ref(false);
        // Android 手机课程列表页不全屏
        if ((isApp && ((androidPort() && versionCompare('8.3.6')) || !androidPort())) ||
            showHeader) {
            appFullScreen();
            showTop.value = true;
        }
        const fixTop = computed(() => {
            if (showHeader) {
                return 0.88 + barHeight.value + 'rem';
            }
            else if (showTop.value) {
                return barHeight.value + 'rem';
            }
            else {
                return '0px';
            }
        });
        let { activeMeta, activeSubDep } = useSubDep();
        let { activeVip } = useVipList();
        const { activeType } = useCourseType();
        // 课程类型 open master_class omo 全部
        const courseType = ref(String(route.params.courseType || ''));
        const pageTitle = ref('课程列表');
        if (courseType.value == 'open') {
            document.title = '公开课';
            pageTitle.value = '公开课';
        }
        else if (courseType.value == 'omo') {
            document.title = 'OMO训练营';
            pageTitle.value = 'OMO训练营';
        }
        else if (courseType.value == 'master_class') {
            document.title = '大师课-会员专享';
            pageTitle.value = '大师课-会员专享';
        }
        const info = computed(() => {
            var str = '';
            if (/^(omo|open|master_class)$/.test(courseType.value)) {
                activeVip.value?.name + '·';
            }
            str += activeType.value?.name + '·';
            if (activeSubType.value?.name) {
                str += activeSubType.value?.name + '·';
            }
            if (activeSubDep.value?.name) {
                str += activeSubDep.value?.name;
            }
            if (activeMeta.value?.name) {
                str += '·' + activeMeta.value.name;
            }
            if (courseType.value == 'omo') {
                str += '·' + activeComing.value?.name;
            }
            return str;
        });
        // 隐藏 webview 导航
        // hiddenAppNavBar()
        const toSearch = () => {
            let query = '?module=COURSE';
            let type = courseType.value;
            if (type) {
                let module = type == 'master_class' ? 'MASTER' : type.toUpperCase();
                query += `&type=${module}`;
            }
            if (isApp) {
                jumpModuleApp({
                    typeId: 'h5',
                    url: `${hostPath}/learn/search${query}`
                });
            }
            else {
                router.push('/search' + query);
            }
        };
        const { courseList, getCourse, courseLoaded, noMore } = useCourseData();
        // 选择列表
        const select = ref(false);
        const showFilter = ref(false);
        const selectTab = () => {
            select.value = true;
            flag = true;
            showFilter.value = true;
        };
        let flag = false;
        const closeFilter = () => {
            if (flag) {
                flag = false;
                setTimeout(() => {
                    showFilter.value = false;
                }, 300);
            }
        };
        // 滚动距离
        const scrollY = ref(0);
        const scrollFn = (e) => {
            scrollY.value = e.y;
        };
        const filterTop = ref(0);
        let filterContent;
        const listBs = ref();
        onMounted(() => {
            filterContent = document.querySelector('.filterWrapper');
            nextTick(() => {
                filterTop.value = filterContent?.offsetTop || 0;
            });
            if (!loading.value) {
                listBs.value?.refreshBs();
            }
            // 缓存判断，重新请求列表
            if (!loading.value && courseList.value.length == 0) {
                getCourse(true);
            }
        });
        const scrollTop = () => {
            listBs.value?.scrollTo(0, 0, 300);
        };
        watch(() => courseLoading.value, n => {
            if (!n) {
                nextTick(() => {
                    filterTop.value = filterContent?.offsetTop || 0;
                });
            }
        });
        weixinShare({
            title: '课程中心',
            image: 'https://img-a.haoyishu.com/images/share/hys_logo.png',
            desc: '好医术课程中心',
            url: location.href
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (showTop.value || _unref(showHeader))
                    ? (_openBlock(), _createBlock(AppTopBar, {
                        key: 0,
                        fixed: true,
                        perch: true,
                        background: 'gray'
                    }))
                    : _createCommentVNode("", true),
                (_unref(showHeader))
                    ? (_openBlock(), _createBlock(HeaderBar, {
                        key: 1,
                        "page-title": pageTitle.value,
                        isColor: false,
                        border: false,
                        top: barHeight.value + 'rem'
                    }, null, 8, ["page-title", "top"]))
                    : _createCommentVNode("", true),
                _createVNode(BetterScroll, {
                    options: {
                        scrollY: true,
                        scrollX: false,
                        click: true,
                        mouseWheel: false,
                        scrollbar: {
                            fade: false,
                            interactive: true
                        },
                        pullUpLoad: true
                    },
                    noMore: _unref(noMore),
                    loaded: _unref(courseLoaded),
                    onUpLoad: _unref(getCourse),
                    domStyle: {
                        position: 'relative',
                        height: `calc(100vh - ${_unref(showHeader) ? 0.88 + barHeight.value : 0}rem)`
                    },
                    ref: (_value, _refs) => {
                        _refs['listBs'] = _value;
                        listBs.value = _value;
                    },
                    onScrollFn: scrollFn
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", {
                                class: "searchBtn flex-align-center p-16 border-box m-auto font-32",
                                onClick: _withModifiers(toSearch, ["stop"])
                            }, _hoisted_6, 8, _hoisted_3)
                        ]),
                        _createVNode(searchTabs, {
                            courseType: courseType.value,
                            select: select.value,
                            vip188: false
                        }, null, 8, ["courseType", "select"]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["p-t16 p-lr32 p-b16", {
                                    grayBgF5: courseType.value == 'omo'
                                }])
                        }, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", {
                                    class: "flex-align-center filterContent linearUp",
                                    ref: (_value, _refs) => {
                                        _refs['filterContent'] = _value;
                                        _isRef(filterContent) ? filterContent.value = _value : filterContent = _value;
                                    }
                                }, [
                                    _createElementVNode("div", _hoisted_8, "共 " + _toDisplayString(_unref(totalCount)) + " 个课程", 1),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["filterBtn font-28 gray-6", {
                                                themeColor: _unref(activeFilter)
                                            }]),
                                        onClick: _withModifiers(selectTab, ["stop"])
                                    }, " 筛选 ", 10, _hoisted_9)
                                ], 512)
                            ]),
                            (_unref(courseList).length)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (courseType.value != 'omo')
                                        ? (_openBlock(), _createBlock(CourseListVue, {
                                            key: 0,
                                            list: _unref(courseList),
                                            courseType: courseType.value
                                        }, null, 8, ["list", "courseType"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courseList), (item) => {
                                                return (_openBlock(), _createBlock(omoListItem, {
                                                    class: "m-b24",
                                                    item: item
                                                }, null, 8, ["item"]));
                                            }), 256))
                                        ])),
                                    _withDirectives(_createElementVNode("div", _hoisted_11, "没有更多了", 512), [
                                        [_vShow, _unref(noMore)]
                                    ])
                                ], 64))
                                : (_openBlock(), _createBlock(Empty, {
                                    key: 1,
                                    type: 'list',
                                    text: '当前暂无内容，探索一下其他内容吧 ~'
                                }))
                        ], 2)
                    ]),
                    _: 1
                }, 8, ["noMore", "loaded", "onUpLoad", "domStyle"]),
                _withDirectives(_createVNode(filterTab, {
                    onCloseFilter: closeFilter,
                    courseType: courseType.value
                }, null, 8, ["courseType"]), [
                    [_vShow, showFilter.value]
                ]),
                _withDirectives(_createElementVNode("div", {
                    onClick: _withModifiers(scrollTop, ["stop"]),
                    class: "linearDown searchInfo font-24 border-box p-lr32",
                    style: _normalizeStyle({ top: _unref(fixTop) })
                }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(info)), 1)
                ], 12, _hoisted_12), [
                    [_vShow, filterTop.value + scrollY.value < 0 && filterTop.value > 0]
                ])
            ]));
        };
    }
});
